import { any } from "prop-types";
import { isIPSAdministrator, isIPSCreator} from "utils/UserInfo";
import React from "react";

export const  defaultStatusColumns = [
    {
      title: 'STATUS',
      width: '25%',
      dataIndex: 'status',
      key: 'status'
    },
    {
      title: 'USER NAME',
      width: '50%',
      dataIndex: 'lastModifiedBy',
      key: 'lastModifiedBy',
      render(text, record) {
        return  (<span>{text}  {record.lastModifiedDate}</span>)
      }
    }
  ];
  export const GateColumns = [
    
    ...defaultStatusColumns
  ]
  export const SEColumns = [
  
    ...defaultStatusColumns
  ]
  export const PCEColumns = [
  
    ...defaultStatusColumns
]
  
export  const shouldDisable = (anyCondition) =>{
  if (isIPSAdministrator()) {
    return false
  } else if (isIPSCreator()) {
    return anyCondition
  }
  return true
}





